import { render, staticRenderFns } from "./GerenciaCadastroAtestados.vue?vue&type=template&id=399d845a"
import script from "./GerenciaCadastroAtestados.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroAtestados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports